<div class="organization-rider-service-levels-panel">
  <p *ngIf="(!organizationServiceLevels || organizationServiceLevels.length === 0) && placeholderMessage; else serviceLevelSelections">
    {{ placeholderMessage }}
  </p>
  <ng-template #serviceLevelSelections>
    <ng-container *ngFor="let organizationServiceLevel of organizationServiceLevels">
      <p
        id="organizationRiderServiceLevels-text-{{ organizationServiceLevel.serviceLevel.code }}AlwaysOffered"
        *ngIf="!organizationServiceLevel.optional"
        class="italic"
      >
        * {{ organizationServiceLevel.serviceLevel.name }} service is always offered
      </p>
    </ng-container>
    <ng-container *ngFor="let optionalOrganizationRiderServiceLevel of optionalOrganizationRiderServiceLevels">
      <p>Is the rider <em>always</em> ok with {{ optionalOrganizationRiderServiceLevel.serviceLevel.name }}?</p>
      <mat-radio-group
        [value]="optionalOrganizationRiderServiceLevel.enabled"
        (change)="handleOptionalOrganizationRiderServiceLevelChange(optionalOrganizationRiderServiceLevel, $event.value)"
      >
        <mat-radio-button
          id="organizationRiderServiceLevel-radio-{{ optionalOrganizationRiderServiceLevel.serviceLevel.code }}-yes"
          [value]="true"
        >
          Yes, the rider is <em>always</em> ok with {{ optionalOrganizationRiderServiceLevel.serviceLevel.name }}.
        </mat-radio-button>
        <mat-radio-button
          id="organizationRiderServiceLevel-radio-{{ optionalOrganizationRiderServiceLevel.serviceLevel.code }}-no"
          [value]="false"
        >
          No, the rider is not <em>always</em> ok with {{ optionalOrganizationRiderServiceLevel.serviceLevel.name }}.
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>
  </ng-template>
</div>
